@switch (model.type) {
<!-- product -->
@case ('product') {
<product class="block"
         [model]="model" />
}
<!-- page -->
@case ('page') {
<page class="block"
      [model]="model" />
}
<!-- category -->
@case ('category') {
<category class="block"
          [model]="model" />
}
}